{
  "loading": "Načítání...",
  "placeholder": "Vybrat…"
}
